module.exports = __webpack_public_path__ + "static/media/12.1890e1d3.jpg";